import { type BoxB2BProgramApiGateway } from "@modules/boxB2BProgram/gateway/boxB2BProgramApi.gateway"
import { LoggerService } from "@modules/common/logger/loggerService"
import {
  type BoxUserProgramItemDto,
  BoxUserProgramItemDtoSchema,
} from "@modules/boxB2BProgram/gateway/boxB2BProgramDto"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { type ProgramSubscriptionDto, ProgramSubscriptionDtoSchema } from "@modules/programs/gateway/programDto"
import {
  type StripeProgramSubscriptionDto,
  StripeProgramSubscriptionDtoSchema,
} from "@modules/programs/gateway/programInfiniteDto"
import { type Page, type PaginatedWrapper, wrapperToPage } from "@modules/utils/paginated"
import dayjs from "dayjs"

export class BoxB2BProgramApi implements BoxB2BProgramApiGateway {
  private baseUrl = "/programs/user-programs/subscribed/pro"
  private duplicateSessionsUrl = `/boxes/slots/duplicate-sessions`
  private buildStripeSubscriptionUrl = (programId: string) => `/programs/${programId}/box`
  private buildSubscriptionUrl = (programId: string) => `/programs/${programId}/box/subscription`

  constructor(private api: ApiClient) {}

  async getBoxSubscribedB2BPrograms(page = 0, size = 40): Promise<Page<BoxUserProgramItemDto>> {
    const resultDto = await this.api.get<PaginatedWrapper<BoxUserProgramItemDto>>(this.baseUrl, {
      params: { page, size },
    })

    const pageResult = wrapperToPage(resultDto.data)

    return {
      ...pageResult,
      content: pageResult.content.map((programSubscriberDto) =>
        LoggerService.parseApiDto(BoxUserProgramItemDtoSchema, programSubscriberDto),
      ),
    }
  }

  async duplicateB2BProgramSessions(
    boxProgramId: string,
    programIdToDuplicateFrom: string,
    startDate: Date,
    endDate: Date,
  ) {
    await this.api.post<{ status: string }>(`${this.duplicateSessionsUrl}`, {
      programIdToDuplicateTo: boxProgramId,
      programIdToDuplicateFrom,
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
    })
  }

  async subscribeToBoxB2BProgram(programId: string) {
    const result = await this.api.post<ProgramSubscriptionDto>(
      `${this.buildStripeSubscriptionUrl(programId)}/subscribe`,
    )
    return LoggerService.parseApiDto(ProgramSubscriptionDtoSchema, result.data)
  }

  async unsubscribeToBoxB2BProgram(programId: string) {
    const result = await this.api.post<ProgramSubscriptionDto>(
      `${this.buildStripeSubscriptionUrl(programId)}/unsubscribe`,
    )
    return LoggerService.parseApiDto(ProgramSubscriptionDtoSchema, result.data)
  }

  async getProgramProStripeSubscriptionInfos(programId: string) {
    const resultDto = await this.api.get<StripeProgramSubscriptionDto | null>(this.buildSubscriptionUrl(programId))
    return resultDto.data ? LoggerService.parseApiDto(StripeProgramSubscriptionDtoSchema, resultDto.data) : null
  }
}
